import { useState, useEffect, useRef } from "react";
import "./ResponseContentLong.css";
import { Question, Response } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { LongResponse, ShortResponse } from "../config/responseSettings";
import config from "environment";
import { LongSettings, ShortSettings } from "../config/questionSettings";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentLongProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentLong = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentLongProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [error, setError] = useState<string>("");

    const [commentHeight, setCommentHeight] = useState<number>(24);
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setText(JSON.parse(responseValues).text || "");
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        if (question.required && text.trim() === "") {
            setError(ResponseErrors.required);
            return;
        }

        const settings = JSON.parse(question.settings) as ShortSettings;

        if (settings.maxCharsOn && text.length > settings.maxChars) {
            setError(ResponseErrors.maxChars);
            return;
        }

        const newResponseValues: string = JSON.stringify({
            text
        } as ShortResponse);

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        
        // if (e.key === "Enter") {
        //     handleSubmit();
        //     return;
        // }

        const settings = JSON.parse(question.settings) as LongSettings;

        console.log("[ResponseContentShort] settings: ", settings);
        
        if (settings.maxCharsOn) {
            if (text.length >= settings.maxChars) {
                if (e.key === "Backspace") {
                    setError((text.length - 1 >= settings.maxChars) ? ResponseErrors.maxChars : "");
                    return;
                } else {
                    setError(ResponseErrors.maxChars);
                    e.preventDefault();
                    return;
                }
            }
        }

        setError(ResponseErrors.none);
    
    }

    const handlePaste = (e: any) => {
        const paste = e.clipboardData.getData('text');
        setText(paste);

        const settings = JSON.parse(question.settings) as ShortSettings;
        
        if (settings.maxCharsOn) {
            if (paste.length >= settings.maxChars) {
                setError(ResponseErrors.maxChars);
                return;
            }
        }

        setError(ResponseErrors.none);
    }

    const handleChange = (e: any) => {
        setText(e.target.value);
    }

    const handleInput = () => {
        if (textareaRef.current) {
            setCommentHeight(textareaRef.current.scrollHeight);
            textareaRef.current.style.height = "auto"; // Reset height to auto to recalculate
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height
        }

        console.log("[ResponseContentLong] set height: ", textareaRef.current?.scrollHeight);
    };

    const requirementsMet = !question.required || (text.trim() !== "");
    
    console.log("[ResponseContentLong] question: ", question);
    console.log("[ResponseContentLong] values: ", responseValues);
    console.log("[ResponseContentLong] text: ", text);


    return (
        <div className="form-content-body">
{/* 
            {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div className="response-content-long-text">
                
                <textarea
                    ref={textareaRef}
                    cols={40}
                    rows={text ? Math.floor(text.length / (isMobileLayout ? 40 : 80)) + 1 : 1}
                    // rows={5} 
                    onInput={handleInput}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    value={text}
                    placeholder="Your answer here.."
                    data-testid="response-content-value"
                    autoFocus={true}
                />
                <div className="response-content-long-bottom">
                    {}
                </div>
            </div>    
            
            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />


        </div>
    )
}